import { ComponentType } from '@angular/cdk/portal';
import { DashboardTile } from '../../../dashboard/models/dashboard-tile.model';
//import { CallParkingTileComponent } from '../../views/call-parking/call-parking-tile.component';
import { CallParkingTileComponent } from '../../views/call-parking/call-parking-tile.component';
import { ClockTileComponent } from '../../views/clock/clock-tile.component';
import { NdtWaitTimesGraphTileComponent } from '../../views/ndt-wait-times-graph-tile/ndt-wait-times-graph-tile.component';
import { PhoneQueuesTileComponent } from '../../views/phone-queues/phone-queues-tile.component';
import { QueueMembersTileComponent } from '../../views/queue-members/queue-members-tile.component';
import { FallbackTileComponent } from '../../views/shared/fallback-tile/fallback-tile.component';

export type TileComponentAccessor = (tileConfig: DashboardTile) => ComponentType<any>;

export const DefaultTileComponentAccessor: TileComponentAccessor = (tileConfig: DashboardTile) => {
   const id = tileConfig.tile.tileId as unknown as string;
   switch (tileConfig.tile.tileId) {
      case Tiles.Clock:
         return ClockTileComponent;
      case Tiles.CallParking:
         return CallParkingTileComponent;
      case Tiles.QueueMembers:
         return QueueMembersTileComponent;
      case Tiles.PhoneQueues:
         return PhoneQueuesTileComponent;
      case Tiles.NDTWaitTimesGraph:
         return NdtWaitTimesGraphTileComponent;
      default:
         return FallbackTileComponent;
   }
};

export enum Tiles {
   CallParking = 'CallParking',
   Clock = 'Clock',
   QueueMembers = 'QueueMembers',
   NDTWaitTimesGraph = 'NDTWaitTimesGraph',
   PhoneQueues = 'PhoneQueues',
}
